import type { QuoteCargoTypesListResponse } from './api';

export const normalizeQuoteCargoTypesList = (list: QuoteCargoTypesListResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.displayValue,
    value: row.lookupCodeId,
  }));
};
